const iccApis = {
  users: {
    singular: 'user',
    plural: 'users',
    paginated: true,
    id: 'userId',
    generatedId: true,
    createMethod: 'POST',
    updateMethod: 'PUT'
  },
  funds: {
    singular: 'fund',
    plural: 'funds',
    paginated: true,
    additionalGetManyFilterParam: { returnFundTags: true },
    additionalGetOneFilterParam: { returnFundTags: true },
    id: 'id',
    createMethod: 'POST',
    updateMethod: 'PUT'
  },
  fundsDistributionList: {
    singular: 'fund',
    plural: 'funds',
    paginated: true,
    fundsDistributionList: true,
    additionalGetManyFilterParam: { returnFundTags: true },
    additionalGetOneFilterParam: { returnFundTags: true },
    id: 'id',
    createMethod: 'POST',
    updateMethod: 'PUT'
  },
  investors: {
    singular: 'investor',
    plural: 'investors',
    paginated: true,
    getMany: false,
    additionalGetOneFilterParam: { returnInvestorTags: true },
    id: 'id',
    createMethod: 'POST',
    updateMethod: 'PUT'
  },
  organizations: {
    singular: 'organization',
    plural: 'organizations',
    paginated: true,
    id: 'id',
    createMethod: 'POST',
    updateMethod: 'PUT'
  },
  resourceuploads: {
    singular: 'resourceupload',
    plural: 'resourceuploads',
    paginated: true,
    createMethod: 'POST',
    id: 'resourceUploadId',
    queryId: 'resourceUploadId' // 'id' by default and for all other APIS !
  },
  userphones: {
    singular: 'userphone',
    plural: 'userphones',
    paginated: true,
    id: ['userId', 'phoneTypeId'],
    createMethod: 'PUT',
    updateMethod: 'PUT'
  },
  userphonetypes: {
    singular: 'userphonetype',
    plural: 'userphonetypes',
    paginated: true,
    id: 'id'
  },
  useraddresses: {
    singular: 'useraddress',
    plural: 'useraddresses',
    paginated: true,
    id: ['userId', 'addressTypeId'],
    createMethod: 'PUT',
    updateMethod: 'PUT'
  },
  useraddresstypes: {
    singular: 'useraddresstype',
    plural: 'useraddresstypes',
    paginated: true,
    id: 'id'
  },
  userauthorizations: {
    singular: 'userauthorization',
    plural: 'userauthorizations',
    paginated: true,
    id: ['userId', 'investorId', 'fundId', 'groupId'],
    createMethod: 'POST',
    updateMethod: 'POST'
  },
  categories: {
    singular: 'category',
    plural: 'categories',
    paginated: true,
    id: 'id',
    createMethod: 'POST',
    updateMethod: 'PUT'
  },
  subcategories: {
    singular: 'subcategory',
    plural: 'subcategories',
    paginated: true,
    id: 'id',
    createMethod: 'POST',
    updateMethod: 'POST'
  },
  fundclasses: {
    plural: 'fundclasses',
    paginated: false,
    id: 'classCode'
  },
  fundinvestors: {
    singular: 'fundinvestor',
    plural: 'fundinvestors',
    paginated: true,
    getMany: false,
    id: ['fundId', 'investorId'],
    createMethod: 'PUT',
    updateMethod: 'PUT'
  },
  countries: {
    singular: 'country',
    plural: 'countries',
    id: 'code',
    paginated: true
  },
  states: {
    singular: 'state',
    plural: 'states',
    id: ['code', 'countryCode'],
    pluralId: 'code',
    paginated: true
  },
  documentpresets: {
    singular: 'documentpreset',
    plural: 'documentpresets',
    id: 'id',
    paginated: true,
    createMethod: 'POST',
    updateMethod: 'PUT'
  },
  documenttypes: {
    singular: 'documenttype',
    plural: 'documenttypes',
    id: 'id',
    paginated: true,
    createMethod: 'POST',
    updateMethod: 'POST'
  },
  documentwatermarks: {
    singular: 'documentwatermark',
    plural: 'documentwatermarks',
    id: 'id',
    paginated: true,
    createMethod: 'POST',
    updateMethod: 'PUT'
  },
  documentsecurities: {
    singular: 'documentsecurity',
    plural: 'documentsecurities',
    id: 'id',
    paginated: false
  },
  fundfamilies: {
    singular: 'fundfamily',
    plural: 'fundfamilies',
    paginated: true,
    id: 'id',
    createMethod: 'POST',
    updateMethod: 'PUT'
  },
  categorytypes: {
    plural: 'category/types',
    id: 'id',
    paginated: false
  },
  currencies: {
    plural: 'currencies',
    id: 'code',
    paginated: false
  },
  mailtemplates: {
    singular: 'mailtemplate',
    plural: 'mailtemplates',
    id: 'id',
    paginated: true,
    createMethod: 'POST',
    updateMethod: 'PUT'
  },
  mailtemplatesonlyinfo: {
    singular: 'mailtemplate',
    plural: 'mailtemplates',
    id: 'id',
    paginated: true,
    createMethod: 'POST',
    updateMethod: 'PUT',
    additionalGetManyFilterParam: { onlyInfo: true },
    additionalGetOneFilterParam: { onlyInfo: true }
  },
  splitmethods: {
    singular: 'splitmethod',
    plural: 'splitmethods',
    id: 'id',
    paginated: false,
    createMethod: 'POST',
    updateMethod: 'PUT'
  },
  documents: {
    plural: 'documents',
    id: 'id',
    paginated: true
  },
  resourceuploaddocuments: {
    plural: 'resourceupload/documents',
    id: 'id',
    paginated: false
  },
  tenantconfigurations: {
    singular: 'tenantconfiguration',
    plural: 'tenantconfigurations',
    paginated: true,
    id: 'id',
    updateMethod: 'PUT'
  },
  groups: {
    singular: 'group',
    plural: 'groups',
    id: 'id',
    paginated: true,
    createMethod: 'POST',
    updateMethod: 'PUT'
  },
  groupcategories: {
    singular: 'groupcategory',
    plural: 'groupcategories',
    paginated: true,
    id: ['groupId', 'categoryOrSubcategoryId'],
    createMethod: 'PUT',
    updateMethod: 'PUT'
  },
  fundterms: {
    singular: 'fund/termandcondition',
    plural: 'funds/termsandconditions',
    paginated: true,
    id: ['termId'],
    queryId: 'termId',
    createMethod: 'POST',
    updateMethod: 'PUT'
  },
  fundtermsrelations: {
    singular: 'funds/termsandconditions/relations', // We are never creation one relation, and that allow us to useCreate and call the multiple api with an array
    plural: 'funds/termsandconditions/relations',
    paginated: true,
    id: ['fundTermId', 'fundId'],
    createMethod: 'POST'
  },
  categoryterms: {
    singular: 'category/termandcondition',
    plural: 'categories/termsandconditions',
    paginated: true,
    id: ['categoryTermId'],
    queryId: 'categoryTermId',
    createMethod: 'POST',
    updateMethod: 'PUT'
  },
  categorytermsrelations: {
    singular: 'categories/termsandconditions/relations',
    plural: 'categories/termsandconditions/relations',
    paginated: true,
    id: ['categoryTermId', 'categoryId'],
    createMethod: 'POST'
  },
  distributionlist: {
    plural: 'resourceupload/distributionlist',
    paginated: false,
    id: 'id'
  },
  roles: {
    singular: 'role',
    plural: 'roles',
    paginated: false,
    id: 'id',
    createMethod: 'POST',
    updateMethod: 'PUT'
  },
  fundtags: {
    singular: 'fundtag',
    plural: 'fundtags',
    paginated: true,
    id: 'id',
    createMethod: 'POST',
    updateMethod: 'PUT'
  },
  investortags: {
    singular: 'investortag',
    plural: 'investortags',
    paginated: true,
    id: 'id',
    createMethod: 'POST',
    updateMethod: 'PUT'
  },
  fundinvestortags: {
    singular: 'fundinvestortag',
    plural: 'fundinvestortags',
    paginated: true,
    id: 'id',
    createMethod: 'POST',
    updateMethod: 'PUT'
  },
  authorities: {
    plural: 'roles/authorities',
    paginated: false,
    id: 'id'
  },
  userroles: {
    plural: 'roles/userroles',
    paginated: false,
    id: ['userId', 'roleId']
  },
  distributionlists: {
    singular: 'distributionlist',
    plural: 'distributionlists',
    paginated: true,
    id: 'id',
    createMethod: 'POST'
  },
  mfamethods: {
    plural: 'user/mfa/methods',
    paginated: false,
    id: 'mfaMethodName'
  },
  reports: {
    singular: 'adminreport',
    plural: 'adminreports',
    paginated: false,
    id: 'id'
  },
  emailarchives: {
    singular: 'emailarchive/emaildetails',
    plural: 'emailarchives',
    id: 'id',
    paginated: true
  },
  emailarchiveattachments: {
    singular: 'emailarchive/attachments',
    plural: 'emailarchive/attachments',
    id: 'id'
  },
  emailarchiverecipients: {
    singular: 'emailarchive/emailrecipients',
    plural: 'emailarchive/emailrecipients',
    id: ['userId', 'fundId', 'investorId'],
    paginated: true
  },
  distributionlistrecipients: {
    singular: 'distributionlist/recipients',
    plural: 'distributionlist/recipients',
    id: 'distributionListId',
    paginated: false
  },
  aliasUdfs: {
    singular: 'user/emailudf',
    plural: 'user/emailudf',
    updateMethod: 'PUT',
    id: 'id',
    paginated: false
  },
  investorcontacts: {
    plural: 'investor/contacts',
    paginated: true,
    id: ['investorId', 'userId']
  },
  primarycontacts: {
    plural: 'investor/primarycontacts',
    paginated: false,
    id: ['investorId', 'documentTypeId', 'type']
  },
  usernotifications: {
    plural: 'usernotifications',
    paginated: false,
    id: [
      'fundId',
      'investorId',
      'documentTypeId',
      'deliveryMethod',
      'parameter'
    ],
    createMethod: 'PUT',
    updateMethod: 'PUT'
  },
  activities: {
    plural: 'activities',
    paginated: true,
    id: 'activityId'
  },
  userudfs: {
    singular: 'userudf',
    plural: 'userudfs',
    paginated: false,
    id: 'userId',
    queryId: 'userId',
    updateMethod: 'PUT'
  },
  investorudfs: {
    singular: 'investorudf',
    plural: 'investorudfs',
    paginated: false,
    id: 'investorId',
    queryId: 'investorId',
    updateMethod: 'PUT'
  },
  fundinvestorudfs: {
    singular: 'fundinvestorudf',
    plural: 'fundinvestorudfs',
    paginated: false,
    id: ['investorId', 'fundId'],
    updateMethod: 'PUT'
  },
  wireinstructions: {
    singular: 'wireinstruction',
    plural: 'wireinstructions',
    paginated: true,
    id: 'id',
    createMethod: 'POST',
    updateMethod: 'PUT'
  },
  investorcount: {
    singular: 'resourceuploads/investors/readcount',
    plural: 'resourceuploads/investors/readcount',
    pluralId: 'resourceUploadId',
    id: 'resourceUploadId',
    paginated: false
  },
  fundtagsassociations: {
    plural: 'fundtags/associations',
    paginated: false,
    id: ['fundTagId', 'fundId']
  },
  investortagsassociations: {
    plural: 'investortags/associations',
    paginated: false,
    id: ['investorTagId', 'investorId']
  },
  fundinvestortagsassociations: {
    plural: 'fundinvestortagsas/associations',
    paginated: false,
    id: ['fundInvestorTagId', 'fundId', 'investorId']
  },
  usersOrphanVisibilityOn: {
    plural: 'users',
    paginated: true,
    id: 'userId',
    additionalGetManyFilterParam: { orphanVisibility: 'ALL_VISIBLE' },
    generatedId: true
  }
};

export default iccApis;
